const data={"info":<>
<h1 style={{fontSize:"1.8rem",fontWeight:"600",textAlign:"left"}}>Aakriti Dhawan</h1> 
<div className="d-flex justify-content-center align-items-center pratha" style={{gap:"5rem"}} >

<div className="right-box-info">

<br/>
<ul className="pra-det">
    <li>Working Committee Head, UPES-CSI</li>
    <li>
        Dedicated to organizing and coordinating technical events.
    </li>
    <li>
        Ensuring smooth operations and effective team collaboration.
    </li>
</ul>
</div>
</div>
</>
}

export default data;
